import { render } from "./MatchGroupMenu.vue?vue&type=template&id=7bd9275a&scoped=true"
import script from "./MatchGroupMenu.vue?vue&type=script&lang=js"
export * from "./MatchGroupMenu.vue?vue&type=script&lang=js"

import "./MatchGroupMenu.vue?vue&type=style&index=0&id=7bd9275a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd9275a"]])

export default __exports__